import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { Badge } from "@/shared/components/ui/badge";
import { LearningsService } from "../services/learningsService";
import type { LearningsTarget } from "../types/LearningTypes";
import { learningsQueryKey } from "../utils/learningsView";

/**
 * O rótulo da aba Learnings com quantas propostas esperam por quem está vendo (AB#87286).
 * O número é só o que a pessoa pode decidir agora — o que espera outra pessoa não conta.
 */
export const LearningsTabLabel = ({ target }: { target: LearningsTarget }) => {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: [...learningsQueryKey(target), "count"],
    queryFn: () => LearningsService.count(target),
    staleTime: 60_000,
  });
  const pending = data?.pending ?? 0;
  return (
    <span className="inline-flex items-center gap-2">
      {t("knowledge.brain.tabs.learnings")}
      {pending > 0 && (
        <Badge variant="secondary" className="h-5 min-w-5 justify-center rounded-full px-1.5 text-[10px]">
          {pending}
        </Badge>
      )}
    </span>
  );
};
